/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeliveryCalculationInitRespVo } from './DeliveryCalculationInitRespVo';
import {
    DeliveryCalculationInitRespVoFromJSON,
    DeliveryCalculationInitRespVoFromJSONTyped,
    DeliveryCalculationInitRespVoToJSON,
    DeliveryCalculationInitRespVoToJSONTyped,
} from './DeliveryCalculationInitRespVo';

/**
 * 
 * @export
 * @interface ResponseDeliveryCalculationInitRespVo
 */
export interface ResponseDeliveryCalculationInitRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseDeliveryCalculationInitRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseDeliveryCalculationInitRespVo
     */
    message?: string;
    /**
     * 
     * @type {DeliveryCalculationInitRespVo}
     * @memberof ResponseDeliveryCalculationInitRespVo
     */
    data?: DeliveryCalculationInitRespVo;
}

/**
 * Check if a given object implements the ResponseDeliveryCalculationInitRespVo interface.
 */
export function instanceOfResponseDeliveryCalculationInitRespVo(value: object): value is ResponseDeliveryCalculationInitRespVo {
    return true;
}

export function ResponseDeliveryCalculationInitRespVoFromJSON(json: any): ResponseDeliveryCalculationInitRespVo {
    return ResponseDeliveryCalculationInitRespVoFromJSONTyped(json, false);
}

export function ResponseDeliveryCalculationInitRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseDeliveryCalculationInitRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : DeliveryCalculationInitRespVoFromJSON(json['data']),
    };
}

export function ResponseDeliveryCalculationInitRespVoToJSON(json: any): ResponseDeliveryCalculationInitRespVo {
    return ResponseDeliveryCalculationInitRespVoToJSONTyped(json, false);
}

export function ResponseDeliveryCalculationInitRespVoToJSONTyped(value?: ResponseDeliveryCalculationInitRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': DeliveryCalculationInitRespVoToJSON(value['data']),
    };
}

